import { createRouter, createWebHistory } from 'vue-router'

import Login from './components/Login.vue'
import Recorvery from './components/Recorvery.vue'
import Dashboard from './components/Dashboard.vue'
import Main from './components/Main.vue'
import History from './components/History.vue'
import Plotting from './components/Plotting.vue'

const routes = [
  {
    path: '/salmontrack/login',
    component: Login,
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/salmontrack/recorvery',
    component: Recorvery,
    meta: {
      title: 'Lupa Password'
    }
  },
  {
    path: '/salmontrack',
    component: Dashboard,
    meta: {
      title: 'Dashboard'
    },
    children: [
      {
        path: '',
        component: Main,
        meta: {
          title: 'Dashboard Main'
        }
      },
      {
        path: 'history',
        component: History,
        meta: {
          title: 'History'
        }
      },
      {
        path: 'plotting',
        component: Plotting,
        meta: {
          title: 'Plotting'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title

  next()
})

export default router
